// PingCheckHandler.jsx
import { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import { NULL_FUNCTION } from '../resource/defaults.js';

const realUserEvents = ['mousemove', 'click', 'scroll'];

export const PingCheckHandler = ({ sendPingChecks = NULL_FUNCTION }) => {
  const runPingCheck = useCallback(() => {
    realUserEvents.forEach(event => {
      window.removeEventListener(event, runPingCheck);
    });
    sendPingChecks();
  }, [sendPingChecks]);

  useEffect(() => {
    realUserEvents.forEach(event => {
      window.addEventListener(event, runPingCheck);
    });
    return () => {
      realUserEvents.forEach(event => {
        window.removeEventListener(event, runPingCheck);
      });
    };
  }, [runPingCheck]);

  return null;
};

PingCheckHandler.propTypes = {
  sendPingChecks: PropTypes.func,
};

export default PingCheckHandler;
